/**
 * 网络服务API地址
 * */
export const { REACT_APP_API, REACT_APP_INIT_TOKEN } = process.env;

/**
 * @description 白名单
 * */
type WhiteList = string[];
export const WHITELIST: WhiteList = ["/user/login"];

/**
 * @description header token key
 * */
export const TOKEN = "TOKEN";

/** 获取polygon 中心点 */
export const getCenterLL = (data: any) => {
  let lng = 0.0;
  let lat = 0.0;
  for (let i = 0; i < data.length; i += 1) {
    lng += parseFloat(data[i][0]);
    lat += parseFloat(data[i][1]);
  }
  lng /= data.length;
  lat /= data.length;
  return [lng, lat];
};

/** 点位色值 中心点 */
export const getHeatColor = (
  max: number,
  valueS: number,
  colorRange: number[][]
) => {
  let value = valueS;
  if (value >= max) {
    value = max;
  }
  const len = colorRange.length;
  const ratio = value / max;
  const idx = Math.floor(ratio * (len - 1));

  const start = colorRange[idx];
  if (!start) {
    return colorRange[len - 1];
  }
  const end = colorRange[idx + 1];
  if (!end) {
    return start.slice(0);
  }
  const step = max / (len - 1);
  const r = Math.max((value - idx * step) / step, 0);
  const res = [];
  for (let i = 0; i < 4; i += 1) {
    let v = start[i] + Math.round((end[i] - start[i]) * r);
    if (v > 255) {
      v = 255;
    } else if (v < 0) {
      v = 0;
    }
    res[i] = v;
  }
  return res;
};
